<script>
import ProductFeature from "@js/components/Sections/Product/Components/ProductFeature.vue";
import CallbackButton from "@js/components/Buttons/CallbackButton.vue";
import {useProductStore} from "@js/store/ProductStore.js";
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue";

export default {
    name: "ProductInfo",
    components: {NumberFormatComponent, CallbackButton, ProductFeature},
    setup() {
        const productStore = useProductStore()

        return {productStore}
    }
}
</script>

<template>
    <div>
        <div class="text-2xl md:text-3xl font-bold flex items-center text-gray-700">
            Цена:
            <div class="ms-2">
                <template v-if="productStore.product.price">
                    <NumberFormatComponent :number="productStore.product.price" append_text=" ₽"/>
                </template>
                <template v-else>
                    Договорная
                </template>
            </div>
        </div>
    </div>
    <hr class="mb-3 mt-3 md:mb-5 md:mt-5"/>
    <div class="flex flex-col gap-1 max-w-[400px] mb-5">
        <ProductFeature v-if="productStore.product.length"
                        :description="productStore.product.length"
                        title="Длина, мм"/>
        <ProductFeature v-if="productStore.product.width"
                        :description="productStore.product.width"
                        title="Ширина, мм"/>
        <ProductFeature v-if="productStore.product.height"
                        :description="productStore.product.height"
                        title="Высота, мм"/>
        <ProductFeature v-if="productStore.product.weight"
                        :description="productStore.product.weight"
                        title="Вес, т"/>
    </div>

</template>

<style scoped lang="scss">

</style>
